const constants = {
	DELETE_ORG_MATERIAL: {
		FAILURE : 'DELETE_ORG_MATERIAL_FAILURE',
		REQUEST : 'DELETE_ORG_MATERIAL_REQUEST',
		SUCCESS : 'DELETE_ORG_MATERIAL_SUCCESS'
	},
	GET_MATERIALS_BY_ORG: {
		CLEAR   : 'GET_MATERIALS_BY_ORG_CLEAR',
		FAILURE : 'GET_MATERIALS_BY_ORG_FAILURE',
		REQUEST : 'GET_MATERIALS_BY_ORG_REQUEST',
		SUCCESS : 'GET_MATERIALS_BY_ORG_SUCCESS'
	},
	GetOrgMaterialPaged: {
		FAILURE : 'GET_ORG_MATERIALS_PAGED_FAILURE',
		REQUEST : 'GET_ORG_MATERIALS_PAGED_REQUEST',
		SUCCESS : 'GET_ORG_MATERIALS_PAGED_SUCCESS'
	},
	RESTORE_ORG_MATERIAL: {
		FAILURE : 'RESTORE_ORG_MATERIAL_FAILURE',
		REQUEST : 'RESTORE_ORG_MATERIAL_REQUEST',
		SUCCESS : 'RESTORE_ORG_MATERIAL_SUCCESS'
	}
}
export default constants